import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'

const lightbox = () => {
  const lightbox = document.querySelector('.lightbox')

  if (lightbox) {
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.lightbox',
      children: 'a',
      pswpModule: () => import('photoswipe')
    })
    lightbox.init()
  }
}
export default lightbox
